module.exports = __webpack_public_path__ + "img/member-pc.f3b82695.jpg";